import React from 'react'
import "./style.css"

const About = () => {
  return (
    <div className='about_container'>
      <h2>About Us</h2>

      <p>Free Online Games - Play Now On NajoxGames</p>
      <p>Welcome to NajoxGames, where you’ll find the latest and best selection of free online games. Enjoy instant play with no downloads, logins, or pop-ups—just fun, uninterrupted gaming!</p>

      <h2>About Games</h2>
      <p>At NajoxGames, our mission is simple: to create a seamless browser-gaming platform that works for users around the world while rewarding developers, both big and small. Our games are designed to be played on desktop, tablet, and mobile devices, so you can enjoy them anywhere—at school, home, or on the go.
      </p>
      <p>Our games are playable on desktop, tablet, and mobile so you can enjoy them at school, at home, or on the road. Every month millions of gamers from all over the world play their favorite games on NajoxGames. Our goal is to create the ultimate online playground. Free and open to all.</p>
      <p>Every month, millions of gamers from around the globe dive into their favorite games on NajoxGames. Our goal is to create the ultimate online playground, free and open to all.
      </p>
      <p>Just load up your favorite games instantly in your web browser and enjoy the fun—no downloads required!
      </p>
    </div>
  )
}

export default About
